module.exports = __webpack_public_path__ + "img/logo2.2e6aa732.png";